import heroImage from '../../images/uu.png';
import './Hero.css';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-content">
          {/* Image on the left */}
          <div className="hero-image">
            <img src={heroImage} alt="उग्रचण्डी आलु प्याज वण्डार" />
          </div>

          {/* Nepali content on the right */}
          <div className="hero-text">
            <h2>उग्रचण्डी आलु प्याज भण्डार  </h2>
            <p>हामी सिधै किसानबाट ताजा आलु, प्याज, लसुन र अदुवा थोक मूल्यमा उपलब्ध गराउँछौं। तपाईंको ढोकामा ताजै वितरण गरिन्छ।</p>

            <div className="hero-features">
              <div className="feature">
                <span className="feature-icon">🌱</span>
                <span>सिधै खेतबाट ताजा उत्पादन</span>
              </div>
              <div className="feature">
                <span className="feature-icon">💰</span>
                <span>थोक मूल्यमा उपलब्ध</span>
              </div>
              <div className="feature">
                <span className="feature-icon">🚚</span>
                <span>मुफ्त वितरण (निश्चित मात्रामा)</span>
              </div>
            </div>

            <div className="hero-buttons">
              <button className="btn primary-btn" onClick={() => scrollToSection('products')}>
                अहिले खरिद गर्नुहोस्
              </button>
              <button className="btn secondary-btn" onClick={() => scrollToSection('contact')}>
                सम्पर्क गर्नुहोस्
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;